import React from 'react';

// Shimmer Text Component
const ShimmerText = ({ text, darkMode }) => {
  return (
    <span className={`shimmer-text ${darkMode ? 'dark' : 'light'}`}>
      {text}
    </span>
  );
};

export default ShimmerText; 